<template>
  <div>
    <v-menu
      ref="monthPickerMenu"
      v-model="monthPickerMenu"
      :close-on-content-click="false"
      :return-value.sync="monthPickerValue"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="auto"
      :disabled="disabled ? disabled : false"
      :dense="dense != null ? dense : false"
      :hide-details="hideDetails != null ? hideDetails : false"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="monthPickerLabel"
          :label="labelValue"
          prepend-inner-icon="mdi-calendar"
          readonly
          v-bind="attrs"
          v-on="on"
          outlined
          :dense="dense != null ? dense : false"
          :hide-details="hideDetails != null ? hideDetails : false"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="monthPickerValue"
        type="month"
        no-title
        scrollable
      >
      </v-date-picker>
    </v-menu>
  </div>
</template>
<script>
import { nextTick } from 'vue'

export default {
  props: [
    'month',
    'year',
    'label',
    'disabled',
    'dense',
    'hideDetails'
  ],
  data () {
    return {
      monthPickerLabel: null,
      monthPickerValue: null,
      monthPickerMenu: false,
      monthsNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    }
  },
  watch: {
    monthPickerValue (newValue) {
      let temp = newValue.split('-')
      let year = temp[0]
      let month = temp[1]
      this.monthPickerLabel = this.monthsNames[parseInt(month) - 1] + ' ' + year
      this.$emit('yearChange', year)
      this.$emit('monthChange', month)
      this.$refs.monthPickerMenu.save(newValue)
      this.$emit('periodChange')
    }
  },
  computed: {
    labelValue: {
      get () {
        return this.label ? this.label : 'Period'
      }
    }
  },
  methods: {
  },
  async mounted () {
    await nextTick()
    if (!this.year && !this.month) {
      let currentDate = new Date()
      this.monthPickerValue = currentDate.getFullYear() + '-' + (currentDate.getMonth() + 1)
      this.monthPickerLabel = this.monthsNames[currentDate.getMonth() + 1] + ' ' + currentDate.getFullYear()
    } else {
      this.monthPickerValue = this.year + '-' + this.month
      this.monthPickerLabel = this.monthsNames[parseInt(this.month) + 1] + ' ' + this.year
    }
  }
}
</script>
